export interface Todo {
  id: number
  text: string
  completed: boolean
}

export interface Filter {
  from: Date
  to: Date
  selectedVenue: String
}

export interface Auth {
  userId: String
  username: String
  firstName: String
  lastName: String
  email: String
  phone: String
  company: String
  role: [Number]
  is_accepted_gdpr: String
  isLoading: Boolean
  error: Object
}

export interface BookingInfo {
  confirms: Number | String
  customerPending: Number | String
  hotelPending: Number | String
  venues: Array<String | Object>
  confirmedBookingValue: Number | String
  confirmedBookingValueSuport: Number | String
  totalBookings: Number | String
  totalBookingsSupport: Number | String
  successBookingRate: Number | String
  revenueEarned: Number | String
  canceledBookings: Number | String
  cancelBookingsSupport: Number | String
  cancelReasons: Array<String | Object>
  orders: Array<Object>
  sourceOfWebsite: Array<Object | String>
  isLoading: Boolean
  error: Object
}

export interface DashboardFutureDetail {
  futureOverallStatus: {
    futureConfirms: String | Number
    futureCustomerPending: String | Number
    futureHotelPending: String | Number
  }
  definiteBookingValue: String | Number
  unconfirmedBookingValue: String | Number
}

export interface DashboardSelectedDurationDetail {
  averageNumbers: {
    averageDelegateValue: String | Number
    averageLeadTime: String | Number
    averageOrderValue: String | Number
  }
  revenueEarned: String | Number
  orders: Array<Object>
  canceledReasons: Array<Object>
  bookingSources: Array<Object>
  totalBookingChart: Array<String | Number>
  definiteBookingChart: Array<String | Number>
  canceledBookingChart: Array<String | Number>
  eventHeldChart: Array<String | Number>
}

export interface DashboardVenues {
  venues: Array<Object>
}

export interface DashboardReducer {
  venueDetail: DashboardVenues
  futureDetail: DashboardFutureDetail
  selectedDurationDetail: DashboardSelectedDurationDetail
}

export interface Language {
  langcode: String
  text: Object
}

export enum ActionType {
  ADD_TODO,
  DELETE_TODO,
  COMPLETE_TODO,
  UNCOMPLETE_TODO,

  SET_FROM_FILTER,
  SET_TO_FILTER,
  SET_SELECTED_VENUE,
  SET_DURATION_FILTER,
  SET_LANGUAGE_FILTER,
  SET_STEP_FILTER,

  FETCH_BOOKINGINFO_SUCCESS,
  FETCH_BOOKINGINFO_FAIL,
  FETCHING_BOOKINGINFO,

  FETCH_DASHBOARD_VENUES_SUCCESS,
  FETCH_DASHBOARD_VENUES_FAIL,
  FETCHING_DASHBOARD_VENUES,
  FETCH_DASHBOARD_FUTURE_SUCCESS,
  FETCH_DASHBOARD_FUTURE_FAIL,
  FETCHING_DASHBOARD_FUTURE,
  FETCH_DASHBOARD_SELECTED_DURATION_SUCCESS,
  FETCH_DASHBOARD_SELECTED_DURATION_FAIL,
  FETCHING_DASHBOARD_SELECTED_DURATION,

  FETCH_LANGUAGE_SUCCESS,
  FETCH_LANGUAGE_FAIL,
  FETCHING_LANGUAGE,

  AUTH_SUCCESS,
  AUTH_FAIL,
  AUTH_ING
}

export interface Action<T> {
  type: ActionType
  payload: T
}
